import { Button, Conditional } from "@result/rui/components";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import useAuthorization from "#/hooks/useAuthorization";

const FormSubmitButtons = ({
  showSubmit = true,
  onSubmit,
  submitLabel,
  submitIcon = "icon-circle-check",
  isLoading,
  isDisabled,

  showReset = true,
  resetLabel,
  resetIcon,
  onReset,

  additionalButtons,
  additionalPosition = "between",

  leftButtons = [],
}) => {
  const { t } = useTranslation();
  const { canWrite } = useAuthorization();

  return (
    <div className={"is-flex is-justify-content-space-between mt-4"}>
      <div className={"buttons"}>
        <Conditional condition={Boolean(leftButtons?.length)}>
          {leftButtons}
        </Conditional>
      </div>
      <div className={"buttons is-right mt-4"}>
        <Conditional condition={additionalPosition === "left"}>
          {additionalButtons}
        </Conditional>
        <Conditional condition={canWrite && showReset}>
          <Button
            onClick={onReset}
            isSubmit={false}
            leftIcon={resetIcon}
            label={resetLabel ?? t("form.reset")}
          />
        </Conditional>
        <Conditional condition={additionalPosition === "between"}>
          {additionalButtons}
        </Conditional>
        <Conditional condition={canWrite && showSubmit}>
          <Button
            className="is-primary ml-2"
            label={submitLabel ?? t("form.submit")}
            leftIcon={submitIcon ?? "icon-circle-check"}
            isLoading={isLoading}
            isDisabled={isDisabled}
            isSubmit={true}
            onClick={onSubmit}
          />
        </Conditional>
        <Conditional condition={additionalPosition === "right"}>
          {additionalButtons}
        </Conditional>
      </div>
    </div>
  );
};

FormSubmitButtons.propTypes = {
  showSubmit: PropTypes.bool,
  onSubmit: PropTypes.func,
  submitLabel: PropTypes.string,
  submitIcon: PropTypes.string,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  showReset: PropTypes.bool,
  resetLabel: PropTypes.string,
  resetIcon: PropTypes.string,
  onReset: PropTypes.func,
  additionalButtons: PropTypes.arrayOf(PropTypes.node),
  additionalPosition: PropTypes.oneOf(["left", "between", "right"]),
  leftButtons: PropTypes.arrayOf(PropTypes.node),
};

export default FormSubmitButtons;
